// When platform support needs to manually mark an item as shipped, they create a fulfillment event
// with some fake carrier data.  We look for this fake data and render more meaningful content.
export const HISTORICAL_SHIPMENT_UPDATE = 'HISTORICAL_SHIPMENT_UPDATE';
